export type TicketEditorDraftType = 'send-note' | 'internal-note' | 'closure-note' | 'solution'

const getNormalizedTicketRecordId = (ticketRecordId: number | null | undefined) => {
  if (typeof ticketRecordId !== 'number' || !Number.isFinite(ticketRecordId)) return null
  return ticketRecordId
}

const getTicketEditorDraftKey = (draftType: TicketEditorDraftType, ticketRecordId: number | null | undefined) => {
  const normalizedTicketRecordId = getNormalizedTicketRecordId(ticketRecordId)
  if (normalizedTicketRecordId == null) return null
  return `ticket-editor-popup-${draftType}-${normalizedTicketRecordId}`
}

export const readTicketEditorDraft = (draftType: TicketEditorDraftType, ticketRecordId: number | null | undefined) => {
  if (typeof window === 'undefined') return null
  const key = getTicketEditorDraftKey(draftType, ticketRecordId)
  if (!key) return null
  return localStorage.getItem(key)
}

export const writeTicketEditorDraft = (
  draftType: TicketEditorDraftType,
  ticketRecordId: number | null | undefined,
  value: string | null | undefined,
) => {
  if (typeof window === 'undefined') return
  const key = getTicketEditorDraftKey(draftType, ticketRecordId)
  if (!key) return
  if (value) {
    localStorage.setItem(key, value)
    return
  }
  localStorage.removeItem(key)
}
